export const header = `
  
    <h1>Premium Pixels & Exclusive Domains</h1>
    <p>
    Take advantage of GiddyUp's proprietary solution that provides Marketing Partners with the most accurate and advanced pixel firing available – stop worrying about tracking issues and focus on what you do best! With our revamped Exclusive Domains you can take advantage of faster page load speeds, automated image optimization, support for Advertorial, VSL, & Listicle domains. Plus with direct linking you can now avoid destination URL mismatches. <a href="https://mphelpcenter.giddyup.io/en/collections/13584092-premium-pixels-exclusive-domains" target="_blank" rel="noreferrer">Learn more about Exclusive Domains &rarr;</a>
    </p>
    <p>
    To gain access to Exclusive Domains, please contact your GiddyUp Account Manager!
    </p>
`;